import { render } from "./contentCreatePersonModalDesktop.vue?vue&type=template&id=418e5665&scoped=true"
import script from "./contentCreatePersonModalDesktop.vue?vue&type=script&lang=js"
export * from "./contentCreatePersonModalDesktop.vue?vue&type=script&lang=js"

import "./contentCreatePersonModalDesktop.vue?vue&type=style&index=0&id=418e5665&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418e5665"]])

export default __exports__